<template>
  <div class="chat-input">
    <chat-image-upload class="chat-image-upload"></chat-image-upload>
    <el-input
      ref="textarea"
      type="textarea"
      autosize
      v-model="message"
      placeholder="說點什麼"
      v-loading="loading"
      @paste.native.capture="handlePaste"
      @keydown.enter.exact.stop.native="handleEnterKey"
      @keydown.enter.exact.shift.native="handleShiftEnterKey"
      @dragover.prevent
      @dragenter.prevent
      @drop.native="handleDrop"
    ></el-input>

    <emoji-dialog class="icon-emoji"></emoji-dialog>
  </div>
</template>
<script>
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';
import { TextMessage } from '@/components/VoiceRoom/message';
import CurrentUserProvider from '@/components/VoiceRoom/currentUserProvider';
import { ChatMessage } from '@/components/VoiceRoom/chatProvider';
import emojiDialog from '@/components/VoiceRoom/component/emoji-dialog';
import chatImageUpload from '@/components/VoiceRoom/component/chat-image-upload';
import { uploadImageToS3 } from '@/api';
import { ImageMessage } from '@/components/VoiceRoom/message';

export default {
  name: 'ChatInput',
  components: {
    'emoji-dialog': emojiDialog,
    'chat-image-upload': chatImageUpload
  },
  props: {},
  data() {
    return {
      message: '',
      loading: false
    };
  },
  watch: {},
  computed: {
    userInfo() {
      return CurrentUserProvider.userInfo;
    },
    uuid() {
      return this.userInfo.uuid;
    },
    nickName() {
      return this.userInfo.nickname;
    },
    level() {
      return this.userInfo.level;
    }
  },
  methods: {
    handleDrop(event) {
      event.preventDefault();
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        const file = files[0];
        const fileType = file.type;
        const imageTypes = [
          'image/jpeg',
          'image/png',
          'image/gif',
          'image/webp'
        ];
        if (imageTypes.includes(fileType)) {
          this.uploadAction(file);
        } else {
          alert('您拖拽的不是图片文件！');
        }
      }
    },
    handlePaste(event) {
      const clipboardData = event.clipboardData;
      const items = clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const file = items[i].getAsFile();
          this.uploadAction(file);
          return;
        }
      }
    },
    async uploadAction(file) {
      try {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('pathPrefix', 'voice-room/temporary/');
        this.loading = true;
        const { data } = await uploadImageToS3(fd);
        if (data) {
          const imageMessage = new ImageMessage(
            this.uuid,
            data,
            this.level,
            this.nickName,
            this.avatar
          );
          await VoiceRoomIM.sendMessage(imageMessage);
          VoiceRoomIM.addNewMessage(
            new ChatMessage({
              action: 'imageReceive',
              userId: this.uuid,
              nickName: this.nickName,
              message: data
            })
          );
        }
        this.message = '';
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.message = '';
      }
    },
    handleEnterKey(event) {
      if (this.message.trim() === '') {
        event.preventDefault();
        return;
      }
      if (!event.shiftKey) {
        event.preventDefault();
        this.sendMessage();
      }
    },
    handleShiftEnterKey(event) {
      event.preventDefault();
      this.message += '\n';
    },
    async sendMessage() {
      if (this.loading) {
        return;
      }
      if (this.message.trim() === '') {
        return;
      }
      try {
        if (this.message) {
          console.log(Boolean(this.message));
          const textMessage = new TextMessage(
            this.message,
            this.level,
            this.nickName
          );
          this.loading = true;
          await VoiceRoomIM.sendMessage(textMessage);
          if (!VoiceRoomIM.dressupInfo) {
            await VoiceRoomIM.getDressUp();
          }
          VoiceRoomIM.addNewMessage(
            new ChatMessage({
              action: 'normal',
              userId: this.uuid,
              command: textMessage.data.command,
              message: this.message,
              nickName: this.nickName,
              dressup: VoiceRoomIM.dressupInfo
            })
          );
          this.message = '';
        }
      } catch (error) {
        console.log(error);
        this.$message.error(error);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.chat-input {
  width: 100%;
  flex: auto;
  display: flex;
  align-items: center;
  padding: 17px 22px 20px 22px;
  position: relative;
  // input {
  //   white-space: pre-wrap;
  //   // word-wrap: break-word;
  //   // overflow: hidden;
  //   // height: auto;
  //   height: 100px;
  //   color: white;
  //   border-radius: 20px;
  //   background: rgba(255, 255, 255, 0.1);
  //   font-size: 14px;
  //   padding: 10px 40px 10px 20px;
  //   width: 100%;
  //   resize: vertical;
  // }
  /deep/ .el-loading-mask {
    background-color: inherit;
    border-radius: 20px;
  }
  /deep/.el-textarea {
    color: white;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.1);
    font-size: 14px;
    padding: 10px 40px 10px 12px;
    .el-textarea__inner {
      border: none;
      background: none;
      color: white;
      @include hideScrollBar(0, 0);
      padding-left: 0;
      padding-right: 0;
    }
    textarea::-webkit-resizer {
      display: none;
      // background-color: #ccc;
      // background-image: url('custom-icon.png');
      // background-repeat: no-repeat;
      // background-position: center;
      // width: 16px;
      // height: 16px;
    }
  }
  .icon-emoji {
    font-size: 0;
    position: absolute;
    right: 30px;
  }
  .btn-send {
    padding: 13px 18px;
    background-color: #de1ae2;
    color: white;
    border: none;
    margin-left: 10px;
  }
  .chat-image-upload {
  }
}
</style>
